import { put, takeLatest } from 'redux-saga/effects'
import { FIND_PLACES, findPlacesFetching, findPlacesSuccess, findPlacesFailed } from '../modules/places'
import { fetchPlaces } from '../api'

function* findPlaces(action) {
  try {
    yield put(findPlacesFetching(true))
    // To be cleaned up after Geoapify feature is live
    const response = yield fetchPlaces(action.payload.term)
    yield put(findPlacesSuccess(response))
  } catch (error) {
    yield put(findPlacesFailed(error))
  }
}

export default function* placesSaga() {
  yield takeLatest(FIND_PLACES, findPlaces)
}
